'use client';

import React, { createContext, useContext, useMemo, useState } from 'react';

import { NetworkKey } from './constants';

interface LockState {
  isRefresh: boolean;
  refresh: () => void;
  network: NetworkKey;
  setNetwork: React.Dispatch<React.SetStateAction<NetworkKey>>;
  isRefreshBalanceBsc: boolean;
  isRefreshBalanceOrai: boolean;
  refreshBalance: (network: NetworkKey) => void;
}

const initialState: LockState = {
  isRefresh: false,
  refresh: () => {},
  network: NetworkKey.Bsc,
  setNetwork: () => {},
  isRefreshBalanceBsc: false,
  isRefreshBalanceOrai: false,
  refreshBalance: () => {},
};

const LockTokenContext = createContext(initialState);

export const LockTokenProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isRefresh, setIsRefresh] = useState<boolean>(false);
  const [network, setNetwork] = useState<NetworkKey>(NetworkKey.Bsc);
  const [isRefreshBalanceBsc, setIsRefreshBalanceBsc] = useState<boolean>(false);
  const [isRefreshBalanceOrai, setIsRefreshBalanceOrai] = useState<boolean>(false);

  const refresh = () => setIsRefresh(!isRefresh);
  const refreshBalance = (network: NetworkKey) =>
    network === NetworkKey.Bsc
      ? setIsRefreshBalanceBsc(!isRefreshBalanceBsc)
      : setIsRefreshBalanceOrai(!isRefreshBalanceOrai);

  const contextValue: LockState = useMemo(() => {
    return {
      isRefresh,
      refresh,
      network,
      setNetwork,
      refreshBalance,
      isRefreshBalanceBsc,
      isRefreshBalanceOrai,
    };
  }, [isRefresh, network, isRefreshBalanceOrai, isRefreshBalanceBsc]);

  return <LockTokenContext.Provider value={contextValue}>{children}</LockTokenContext.Provider>;
};

export const useLockContext = () => useContext(LockTokenContext);
